// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rS6n","buttons":"styles_buttons__2Hr6e"};